import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Info } from '@assets/svg/icons';

const BusinessSidebar: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <h2>{t('sidebar.business.h2')}</h2>
      <p>{t('sidebar.business.paragraph')}</p>
      <dl>
        <dt>{t('sidebar.business.dt1')}</dt>
        <dd>
          <Info className='icon-info' />
          {t('sidebar.business.dd1')}
        </dd>
        <dt>{t('sidebar.business.dt2')}</dt>
        <dd>
          <Info className='icon-info' />
          {t('sidebar.business.dd2')}
        </dd>
      </dl>
    </>
  );
};

export default BusinessSidebar;
